import {TRONWalletAdapter} from "../WalletAdapter";

export class BitgetAdapter implements TRONWalletAdapter {
    name = "Bitget Wallet";
    website = "https://web3.bitget.com/zh-CN/wallet-download"
    walletKey = "bitget"

    async isInstalled() {
        return typeof window.bitkeep !== "undefined" && typeof window.bitkeep.tronWeb !== "undefined" && typeof window.bitkeep.tronLink !== "undefined"
    }

    async connect(): Promise<string> {
        if (!await this.isInstalled()) throw new Error("Bitkeep Wallet is not installed");
        await window.bitkeep.tronLink.request({method: "tron_requestAccounts"});
        return window.bitkeep.tronWeb.defaultAddress.base58
    }

    async signMessage(message: string): Promise<string> {
        return await window.bitkeep.tronWeb.trx.signMessageV2(message)
    }
}
